const BANDS = [
  { range: "Classes 7 - 10", title: "Explore widely", points: ["Discover the kinds of work that match your interests", "Try new clubs, projects and activities", "Keep the right subject doors open", "Talk through Class 11 subject choices as a family"] },
  { range: "Classes 9 - 12", title: "Look ahead with clarity", points: ["Courses and degrees worth exploring", "Colleges and universities in India worth exploring", "Entrance exams to know about, like JEE, NEET, CUET, CLAT and NID DAT", "Simple next steps for the year ahead"] },
];

export default function ClassBands() {
  return (
    <section className="ds-section bg-ds-creamalt" data-testid="landing-class-bands">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-16 items-end" data-reveal>
          <h2 className="ds-h2 lg:col-span-6">The right guidance for where you are today.</h2>
          <p className="lg:col-span-6 text-[17px] text-ds-inksoft leading-relaxed">A Class 7 student and a Class 12 student are at very different points. The questions and the report meet each student exactly where they are.</p>
        </div>
        <div className="mt-12 grid md:grid-cols-2">
          {BANDS.map((b, i) => (
            <div key={b.range} className={`py-6 md:py-2 ${i ? "border-t md:border-t-0 md:border-l border-dashed border-ds-plum/30 md:pl-14" : "md:pr-14"}`} data-testid={`class-band-${i}`} data-reveal>
              <p className="text-sm font-semibold text-ds-plum">{b.range}</p>
              <h3 className="mt-2 font-display text-3xl font-semibold text-ds-plumdeep">{b.title}</h3>
              <ul className="mt-6 space-y-4">
                {b.points.map((p) => (
                  <li key={p} className="flex gap-3 text-[16px] text-ds-ink leading-relaxed">
                    <svg viewBox="0 0 24 24" className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true"><path d="M12 21s6-5.3 6-10.3a6 6 0 1 0-12 0C6 15.7 12 21 12 21Z" fill={i ? "#4F0341" : "#D9822B"} /><circle cx="12" cy="10.5" r="2.2" fill="#F4EBDD" /></svg>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
